module.exports = __webpack_public_path__ + "media/images/responsive/icon/icon_arrow_black-38de8b832eb26375f05f16f3777948ba.svg";